import { Context } from "@src/context/SettingsContext"
import { useContext } from "react"

export default function useSettingsContext() {
  return useContext(Context)
}
